module.exports = __webpack_public_path__ + "img/slider3.120a0de2.svg";